import { toSentenceCase } from "./string";

export const getHash = () => window.location.hash;

export const getHostname = () => window.location.hostname;

export const getHref = () => window.location.href;

export const getOrigin = () => window.location.origin;

export const navigateTo = (url) => {
  window.location.href = url;
};

export const reloadPage = () => {
  window.location.reload();
};

export const getCloudEnvironment = (host = window.location.host) => {
  const site = (host || "").replace(/\.visiblethread\.com/, "");

  if (!site || site.includes("localhost")) {
    return "development";
  }

  return site
    .split(/[._-]/)
    .map((part, index) => {
      if (index === 0) {
        return part.toLowerCase();
      }
      return toSentenceCase(part);
    })
    .join("");
};
